<div>

  <div [ngClass]="{ 'related-links-grid-2-column': columns == '2',  'related-links-grid-3-column': columns == '3' }"
    class="add-grid pb-20">
    <ng-container *ngFor="let card of cards;">
      <div *ngIf="card === 'custom-rubber'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/case-study-finding-a-custom-rubber-solution-for-automation/">
          <img src="/assets/site/images/case-study-1.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Case Study</h5>
          <h5>
            <a href="https://www.marcorubber.com/blog/case-study-finding-a-custom-rubber-solution-for-automation/">
              Finding a Custom Rubber Solution for Automation
            </a>
          </h5>
          <p>Marco Rubber & Plastics engineered a custom rubber solution for automation for use in the food and beverage
            industry.</p>
        </div>
      </div>
      <div *ngIf="card === 'custom-sealing'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/case-study-custom-sealing-solution-solves-issues/">
          <img src="/assets/site/images/case-study-2.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Case Study</h5>
          <h5>
            <a href="https://www.marcorubber.com/blog/case-study-custom-sealing-solution-solves-issues/">
              Custom Sealing Solution Solves Issues
            </a>
          </h5>
          <p>Approached with a high temperature and high pressure scenario, Marco Rubber & Plastics designed a
            high-performing custom sealing solution.</p>
        </div>
      </div>
      <div *ngIf="card === 'developing-seal'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/case-study-developing-a-custom-seal-for-industrial-printing/">
          <img src="/assets/site/images/case-study-3.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Case Study</h5>
          <h5>
            <a href="https://www.marcorubber.com/blog/case-study-developing-a-custom-seal-for-industrial-printing/">
              Developing a Custom Seal for Industrial Printing
            </a>
          </h5>
          <p>Marco Rubber & Plastics engineered a custom seal for industrial printing, adjusting for a host of
            requirements along the way.</p>
        </div>
      </div>
      <div *ngIf="card === 'sanitary-gasket'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/sanitary-gaskets-ensuring-safety-and-compliance-in-the-food-and-beverage-industry/">
          <img src="/assets/site/images/case-study-4.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Article</h5>
          <h5>
            <a
              href="https://www.marcorubber.com/blog/sanitary-gaskets-ensuring-safety-and-compliance-in-the-food-and-beverage-industry/">
              Sanitary Gaskets: Ensuring Safety and Compliance in the Food and Beverage Industry
            </a>
          </h5>
          <p>Sanitation and safety are critical components of manufacturing gaskets for use with food and beverages.</p>
        </div>
      </div>
      <div *ngIf="card === 'specialized-solution'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/specialized-solutions-pool-o-rings-and-gaskets/">
          <img src="/assets/site/images/case-study-5.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Case Study</h5>
          <h5>
            <a href="https://www.marcorubber.com/blog/specialized-solutions-pool-o-rings-and-gaskets/">
              Specialized Solutions: Pool O-Rings and Gaskets
            </a>
          </h5>
          <p>Pool o-rings and gaskets serve specific purposes and need to account for many factors to ensure performance
            in those applications.</p>
        </div>
      </div>
      <div *ngIf="card === 'silicone-benefits'" class="add-flex flex-column bg-white card">
        <a class="add-flex flex-column"
          href="https://www.marcorubber.com/blog/examining-the-benefits-of-silicone-rubber/">
          <img src="/assets/site/images/case-study-6.webp">
        </a>
        <div class="p-20 flex-1">
          <h5 class="color-secondary">Case Study</h5>
          <h5>
            <a href="https://www.marcorubber.com/blog/examining-the-benefits-of-silicone-rubber/">
              Examining the Benefits of Silicone Rubber
            </a>
          </h5>
          <p>Examine the benefits of silicone rubber, a versatile and flexible elastomer that is critical in medical,
            food & beverage, and more industries.</p>
        </div>
      </div>
    </ng-container>
  </div>

  <p>
    <a href="https://www.marcorubber.com/blog/?s=custom+rubber">
      Check out our blog for additional case studies and articles
    </a>
  </p>
</div>